"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CART_STATIC", {
  enumerable: true,
  get: function get() {
    return _cart["default"];
  }
});
Object.defineProperty(exports, "CHECKOUT_STATIC", {
  enumerable: true,
  get: function get() {
    return _checkout["default"];
  }
});
exports.Copy = void 0;
Object.defineProperty(exports, "DELIVERY_FORM_STATIC", {
  enumerable: true,
  get: function get() {
    return _deliveryForm["default"];
  }
});
Object.defineProperty(exports, "ELEMENTS_STATIC", {
  enumerable: true,
  get: function get() {
    return _elements["default"];
  }
});
Object.defineProperty(exports, "FORGOT_PASSWORD_STATIC", {
  enumerable: true,
  get: function get() {
    return _forgotPassword["default"];
  }
});
Object.defineProperty(exports, "HEADER_STATIC", {
  enumerable: true,
  get: function get() {
    return _header["default"];
  }
});
Object.defineProperty(exports, "ITEM_DETAILS_STATIC", {
  enumerable: true,
  get: function get() {
    return _itemDetails["default"];
  }
});
Object.defineProperty(exports, "KIOSK_STATIC", {
  enumerable: true,
  get: function get() {
    return _kiosk["default"];
  }
});
Object.defineProperty(exports, "LIVE_SEARCH_STATIC", {
  enumerable: true,
  get: function get() {
    return _liveSearch["default"];
  }
});
Object.defineProperty(exports, "LOCATIONS_STATIC", {
  enumerable: true,
  get: function get() {
    return _locations["default"];
  }
});
Object.defineProperty(exports, "LOCATION_LIST_STATIC", {
  enumerable: true,
  get: function get() {
    return _locationList["default"];
  }
});
Object.defineProperty(exports, "LOGIN_SIGNUP_STATIC", {
  enumerable: true,
  get: function get() {
    return _loginSignUp["default"];
  }
});
Object.defineProperty(exports, "LOGIN_STATIC", {
  enumerable: true,
  get: function get() {
    return _login["default"];
  }
});
Object.defineProperty(exports, "LOGOUT_STATIC", {
  enumerable: true,
  get: function get() {
    return _logout["default"];
  }
});
Object.defineProperty(exports, "MENU_STATIC", {
  enumerable: true,
  get: function get() {
    return _menu["default"];
  }
});
Object.defineProperty(exports, "PASSWORD_STATIC", {
  enumerable: true,
  get: function get() {
    return _password["default"];
  }
});
Object.defineProperty(exports, "PAYMENT_FORM_STATIC", {
  enumerable: true,
  get: function get() {
    return _paymentForm["default"];
  }
});
Object.defineProperty(exports, "PROFILE_STATIC", {
  enumerable: true,
  get: function get() {
    return _profile["default"];
  }
});
Object.defineProperty(exports, "RG_INFO_STATIC", {
  enumerable: true,
  get: function get() {
    return _rgInfo["default"];
  }
});
Object.defineProperty(exports, "SIGN_UP_STATIC", {
  enumerable: true,
  get: function get() {
    return _signUp["default"];
  }
});
Object.defineProperty(exports, "UPDATE_EMAIL_STATIC", {
  enumerable: true,
  get: function get() {
    return _updateEmail["default"];
  }
});
Object.defineProperty(exports, "UPDATE_PHONE_STATIC", {
  enumerable: true,
  get: function get() {
    return _updatePhone["default"];
  }
});
Object.defineProperty(exports, "VALIDATE_LOGIN_STATIC", {
  enumerable: true,
  get: function get() {
    return _validaLogin["default"];
  }
});
exports["default"] = void 0;

var _elements = _interopRequireDefault(require("./elements"));

var _deliveryForm = _interopRequireDefault(require("./deliveryForm"));

var _forgotPassword = _interopRequireDefault(require("./forgotPassword"));

var _itemDetails = _interopRequireDefault(require("./itemDetails"));

var _locationList = _interopRequireDefault(require("./locationList"));

var _login = _interopRequireDefault(require("./login"));

var _loginSignUp = _interopRequireDefault(require("./loginSignUp"));

var _password = _interopRequireDefault(require("./password"));

var _paymentForm = _interopRequireDefault(require("./paymentForm"));

var _signUp = _interopRequireDefault(require("./signUp"));

var _updateEmail = _interopRequireDefault(require("./updateEmail"));

var _updatePhone = _interopRequireDefault(require("./updatePhone"));

var _validaLogin = _interopRequireDefault(require("./validaLogin"));

var _header = _interopRequireDefault(require("./header"));

var _cart = _interopRequireDefault(require("./cart"));

var _checkout = _interopRequireDefault(require("./checkout"));

var _liveSearch = _interopRequireDefault(require("./liveSearch"));

var _locations = _interopRequireDefault(require("./locations"));

var _logout = _interopRequireDefault(require("./logout"));

var _menu = _interopRequireDefault(require("./menu"));

var _profile = _interopRequireDefault(require("./profile"));

var _rgInfo = _interopRequireDefault(require("./rgInfo"));

var _overrideData = _interopRequireDefault(require("./overrideData.json"));

var _kiosk = _interopRequireDefault(require("./kiosk"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var CopyStatic = {
  ELEMENTS_STATIC: _elements["default"],
  DELIVERY_FORM_STATIC: _deliveryForm["default"],
  FORGOT_PASSWORD_STATIC: _forgotPassword["default"],
  ITEM_DETAILS_STATIC: _itemDetails["default"],
  LOCATION_LIST_STATIC: _locationList["default"],
  LOGIN_STATIC: _login["default"],
  LOGIN_SIGNUP_STATIC: _loginSignUp["default"],
  PASSWORD_STATIC: _password["default"],
  PAYMENT_FORM_STATIC: _paymentForm["default"],
  SIGN_UP_STATIC: _signUp["default"],
  UPDATE_EMAIL_STATIC: _updateEmail["default"],
  UPDATE_PHONE_STATIC: _updatePhone["default"],
  VALIDATE_LOGIN_STATIC: _validaLogin["default"],
  HEADER_STATIC: _header["default"],
  CART_STATIC: _cart["default"],
  CHECKOUT_STATIC: _checkout["default"],
  LIVE_SEARCH_STATIC: _liveSearch["default"],
  LOCATIONS_STATIC: _locations["default"],
  LOGOUT_STATIC: _logout["default"],
  MENU_STATIC: _menu["default"],
  PROFILE_STATIC: _profile["default"],
  RG_INFO_STATIC: _rgInfo["default"],
  KIOSK_STATIC: _kiosk["default"]
};
var Copy = Object.entries(CopyStatic).reduce(function (accu, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  if (_overrideData["default"][key]) {
    accu[key] = _objectSpread(_objectSpread({}, value), Object.entries(_overrideData["default"][key]).reduce(function (accu2, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key2 = _ref4[0],
          value2 = _ref4[1];

      if (!value2) {
        return accu2;
      }

      return _objectSpread(_objectSpread({}, accu2), {}, _defineProperty({}, key2, value2));
    }, {}));
  }

  return accu;
}, CopyStatic);
exports.Copy = Copy;
var _default = Copy;
exports["default"] = _default;